import React from 'react';
import BaseScreenWithButton from '../../../../../components/base-screen-with-button/BaseScreenWithButton.component';
import StepHeader from '../step-header/StepHeader.component';
import StepTitle from '../step-title/StepTitle.component';

export default function StepScreen(props) {
  const {
    children,
    buttonProps,
    scrollDisable,
    icon,
    title,
    description,
    iconSize,
    titleStyle,
    descriptionStyle,
    hideHeader,
     countdown = null,     
    countdownStyle = {}, 
    ...rest
  } = props;

  return (
    <BaseScreenWithButton
      buttonProps={buttonProps}
      scrollDisable={scrollDisable}>
      {!hideHeader && <StepHeader {...rest} />}
      <StepTitle
        icon={icon}
        title={title}
        description={description}
        iconSize={iconSize}
        titleStyle={titleStyle}
        countdown={countdown}
        countdownStyle={countdownStyle}
        descriptionStyle={descriptionStyle}
      />
      {children}
    </BaseScreenWithButton>
  );
}
